module.exports = __webpack_public_path__ + "img/dash-03.a44d1eb3.jpg";